import { hotelsPerPage } from 'constants/';

/**
 * Generates a unique id
 *
 * @returns {string} A random generated unique id
 *
 * @private
 */
export const generateUUID = () => {
    let time = new Date().getTime();

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, pos => {
        /* eslint-disable no-bitwise, no-mixed-operators */
        const rand = (time + Math.random() * 16) % 16 | 0;
        time = Math.floor(time / 16);

        return (pos === 'x' ? rand : (rand & 0x7) | 0x8).toString(16);
        /* eslint-enable no-bitwise, no-mixed-operators */
    });
};

/**
 * Test if string has an s at the end and add appropriate apostrophe
 *
 * @param {string} string The string to check
 *
 * @returns {string} The same string with 's' at the end
 */
export const addApostrophe = string => {
    if (string[string.length - 1].toLowerCase() === 's') {
        return `${string}'`;
    }

    return `${string}'s`;
};

/**
 * Gets the offset for the query based on page
 *
 * @param {string|number} page The page number
 * @param {number} perPage Number of items per page
 *
 * @returns {number} The offset for the page
 */
export const getOffset = (page, perPage = hotelsPerPage) => {
    // default to 0
    if (!page || page <= 1) {
        return 0;
    }

    return (page - 1) * perPage;
};

/**
 * Takes in a string-like number and converts it to a Number
 *
 * @param {string} str String-like number
 *
 * @returns {number} The Number, defaults to 1 if string contains no digits
 */
export const getPageFromString = str => {
    // if non-digit or digit over 999
    if (str.match(/\D|\d{4,}/)) {
        return 1;
    }

    return Number(str) || 1;
};

/**
 * Gets the page number from props.location.query
 *
 * @param {object} props Object of component props
 *
 * @returns {number} Returns the page number
 */
export const getPage = props => getPageFromString(((props.location || {}).query || {}).p || '');
